import React from 'react';
import skills from '../../../data/skills';

const RESUME_URL =
	'https://drive.google.com/file/d/1O4UxXOZdk4QJonOE6-0Ly0jju9DViJn1/view?usp=sharing';

const ResumeApp = () => {
	const topSkills = [...skills].sort((a, b) => b.value - a.value).slice(0, 4);

	return (
		<div className="font-os flex h-full flex-col bg-os-surface2 text-os-text">
			<div className="flex flex-none items-center justify-between gap-3 border-b border-white/10 bg-os-chrome/80 px-4 py-2.5 backdrop-blur-md">
				<div className="flex min-w-0 items-center gap-2 text-xs text-os-textdim">
					<i className="fa-regular fa-file-lines" />
					<span className="truncate">Sam_Togun_Resume.pdf</span>
					<span className="hidden text-os-textdim/60 sm:inline">&middot; 1 page</span>
				</div>
				<div className="flex flex-none items-center gap-2">
					<a
						href={RESUME_URL}
						target="_blank"
						rel="noopener noreferrer"
						className="inline-flex items-center gap-1.5 rounded-md border border-white/10 bg-os-surface3 px-3 py-1.5 text-xs font-medium text-os-text transition-colors hover:bg-os-surface3/70 active:bg-os-surface3/50"
					>
						<i className="fa-solid fa-arrow-up-right-from-square text-[11px]" />
						<span className="hidden sm:inline">Open in New Tab</span>
						<span className="sm:hidden">Open</span>
					</a>
					<a
						href={RESUME_URL}
						target="_blank"
						rel="noopener noreferrer"
						download
						className="inline-flex items-center gap-1.5 rounded-md bg-os-accent px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-os-accent/90 active:bg-os-accent/80"
					>
						<i className="fa-solid fa-download text-[11px]" />
						<span>Download</span>
					</a>
				</div>
			</div>

			<div className="flex-1 overflow-y-auto px-4 py-8 sm:px-8">
				<div className="mx-auto w-full max-w-[640px] rounded-[2px] bg-[#fbfbfa] text-[#1d1d1f] shadow-[0_20px_50px_rgba(0,0,0,0.55)] ring-1 ring-black/10">
					<div className="px-8 py-10 sm:px-14 sm:py-14">
						<div className="flex flex-col items-center text-center">
							<div className="h-20 w-20 overflow-hidden rounded-full border border-black/10 shadow-sm">
								<img
									src="https://i.ibb.co/60cRjycV/pana-886777-img-only.jpg"
									alt="Sam Togun"
									className="h-full w-full object-cover"
								/>
							</div>
							<h1 className="mt-4 text-2xl font-semibold tracking-tight text-[#1d1d1f]">
								Sam Togun
							</h1>
							<p className="mt-1 text-sm font-medium text-[#0a84ff]">
								Senior Backend Engineer &amp; Solutions Architect
							</p>
							<div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs text-[#6e6e73]">
								<span className="inline-flex items-center gap-1.5">
									<i className="fa-solid fa-location-dot" />
									Stavanger, Norway
								</span>
								<span className="inline-flex items-center gap-1.5">
									<i className="fa-solid fa-envelope" />
									oluwatobitogun@gmail.com
								</span>
								<span className="inline-flex items-center gap-1.5">
									<i className="fa-brands fa-linkedin" />
									linkedin.com/in/oluwatobi-togun
								</span>
								<span className="inline-flex items-center gap-1.5">
									<i className="fa-brands fa-github" />
									github.com/TOGUNOLUWATOBI
								</span>
							</div>
						</div>

						<div className="my-8 h-px bg-black/10" />

						<div>
							<h2 className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-[#6e6e73]">
								Summary
							</h2>
							<p className="text-sm leading-relaxed text-[#3a3a3c]">
								I'm Sam Togun, a Senior Backend Engineer &amp; Solutions Architect. I specialize in
								building scalable, reliable backend systems and cloud solutions for modern
								businesses. I architect and build scalable backend systems that power modern
								applications. With expertise in cloud technologies and microservices, I help
								businesses achieve reliability and performance at scale.
							</p>
						</div>

						<div className="my-8 h-px bg-black/10" />

						<div>
							<h2 className="mb-3 text-[11px] font-semibold uppercase tracking-wider text-[#6e6e73]">
								Key Skills
							</h2>
							<div className="flex flex-wrap gap-2">
								{topSkills.map(skill => (
									<span
										key={skill.label}
										className="rounded-full bg-[#0a84ff]/10 px-3 py-1 text-xs font-medium text-[#0a84ff]"
									>
										{skill.label}
									</span>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResumeApp;
